import { useDict } from '../contexts/LanguageContext';

const Maintenance = () => {
    const dict = useDict();

    return (
        <div>
            <div className="flex-justify-content-center">
                <text className="maintenance-text">{dict.maintenanceText}</text>
            </div>
            <div className="text-align-center">{dict.maintenanceInfo}</div>
        </div>
    );
};

export default Maintenance;
